export default __webpack_public_path__ + "static/media/icon-notification.4b770b43.svg";